import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const TooltipDownload = ({ children }) => {
    return (
        <div className="tooltip-container">
            {children}
            <div className="tooltip-content">
                <span className="tooltipDownload-text">Baixar</span>
                <FontAwesomeIcon icon={faPlay} className="icon-triangle-download" />
            </div>
        </div>
    )
}